/**
 * DEMO BUILD — no backend.
 *
 * This module used to construct a real `@supabase/supabase-js` client from
 * `VITE_SUPABASE_URL` / `VITE_SUPABASE_ANON_KEY` and threw at import time when
 * either was missing. The CRM is now a self-contained visual reference (see
 * TAB_ARCHITECTURE.md, "Direction: this is a visual reference, not production
 * software"): every `supabase.from(...)` across the app is answered by an
 * in-memory fake seeded from the snapshot in `src/demo/data`, and writes live
 * only until the page reloads.
 *
 * The export name and type are unchanged on purpose — the ~310 call sites did
 * not have to move. `@supabase/supabase-js` stays a dependency for its TYPES
 * only (`Session`, `User`, `SupabaseClient`); no network client is created.
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '~/types/database';
import { createFakeSupabase } from '~/demo/client/fakeSupabase';

export const supabase = createFakeSupabase() as unknown as SupabaseClient<Database>;
